import usePermission from 'gcs-common/hooks/usePermission';
import PropTypes from 'prop-types';

const PermissionProtectedRoute = ({ permission, children }) => {
  const hasPermission = usePermission(permission);
  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};

PermissionProtectedRoute.propTypes = {
  permission: PropTypes.array.isRequired,
  children: PropTypes.element.isRequired,
};

export default PermissionProtectedRoute;
